import React from 'react';
import './style.scss';

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
};

const Tooltip = ({ children, content, disabled }: TooltipProps) => (
  <div className="cart-tooltip-wrapper">
    {children}
    {!disabled && (
      <div className="cart-tooltip">
        {content}
        <span />
      </div>
    )}
  </div>
);

export { Tooltip };
